import { BaseEntity } from '../core/entities/base.entity';

export type MotivatingFontSize = '' | 'normal' | 'large' | 'xLarge';

export interface MotivatingFeedbackEntry {
  text: string
  color: string
  fontSize: MotivatingFontSize
}

export interface FeedbackTryEntry {
  from: number
  to: number
  message: string[]
}

export class FeedbackEntity extends BaseEntity {
  subjectId!: string;
  firstTry!: FeedbackTryEntry[];
  secondTry!: FeedbackTryEntry[];
  motivating!: string[];
  updated!: Date;
  changedBy!: string;
  version!: number;
}
